import { ShadowProperties } from './types';

export const shadowRegex = /^(-?\d+px\s+)(-?\d+px\s+)(-?\d+px\s+)?(-?\d+px\s+)?((?=#|rgb(?=a)*|var(?=a)*).*)$/;

export const defaultShadow = {
  offsetX: '0px',
  offsetY: '0px',
  blur: '0px',
  spread: '0px',
  color: '#000',
  hasSpread: false,
};

export const parseShadowValue = (str: string, hasSpread: boolean): ShadowProperties => {
  const match = str.match(shadowRegex);

  if (!match) {
    return defaultShadow;
  }

  const [offsetX, offsetY, blur, spread, color] = match
    .slice(1, 6)
    .map((val) => (val ? val.trim() : val));

  return {
    offsetX,
    offsetY,
    blur: blur || '0px',
    spread: spread || '0px',
    color,
    hasSpread,
  };
};

export const renderShadowProperties = ({
  offsetX,
  offsetY,
  blur,
  spread,
  color,
  hasSpread,
}: ShadowProperties) => `${offsetX} ${offsetY} ${blur}${hasSpread ? ` ${spread}` : ''} ${color}`;

const pixelValueRegex = /^(-?\d+px)$/;

export const wrapPixelValue = (str: string) => (pixelValueRegex.test(str) ? str : '0px');
